// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"49f954f9","247":"9330ecfd","422":"6497b1cb","459":"ab0651cb","627":"d0055107","768":"cbd715ea","834":"916e3006","923":"6dfe6fd5","938":"fb6d8163"}[chunkId] + ".chunk.js";
};